import _ from 'underscore';
import $ from 'jquery';

export default class OfferCampaignCreateDialog {
  constructor($scope, $rootScope, $q, OfferCampaignService) {
    $scope.$on('show_create_campaign', function(event, data) {
      $scope.total_count = data.total_count;
      $scope.current_index = data.current_index;
      $scope.send = data.send || 0;
      _.each($scope.steps, function(step) {
        step.processing = false;
        step.completed = false;
        step.progress_started = false;
        step.progress = 0;
        $scope.offer_campaign_id = null;
      });
      window.openFancyboxDialog('div#offer_campaign_create_dialog');
      create_campaign(data.offer_id, data.campaign_settings, data.deferred || null);
    });

    $scope.steps = [
      {
        id: 1,
        title: 'Create Offer Campaign'
      },
      {
        id: 2,
        title: 'Copy Basic Infos'
      },
      {
        id: 3,
        title: 'Find and Add Recipients'
      },
      {
        id: 4,
        title: 'Create XLS for General Recipients'
      },
      {
        id: 5,
        title: 'Calculate Qty for Special Recipients'
      },
      {
        id: 6,
        title: 'Embed matched for Special Recipients'
      },
      {
        id: 7,
        title: 'Create XLS for Special Recipients'
      },
      {
        id: 8,
        title: 'Ignore PI XLS for Special Recipients'
      },
      {
        id: 9,
        title: 'Mark template done for Special Recipients'
      }
    ];

    function set_processing(step_index) {
      if (step_index > 0) {
        $scope.steps[step_index - 1].processing = false;
        $scope.steps[step_index - 1].completed = true;
      }
      $scope.steps[step_index].processing = true;
    }

    function create_general_xls(recipients) {
      $scope.steps[3].progress = 0;
      $scope.steps[3].progress_started = true;
      return recipients.reduce(function(promise, recipient, index) {
        return promise.then(function() {
          $scope.steps[3].progress = Math.ceil((index / recipients.length) * 100);
          return OfferCampaignService.create_general_xls($scope.offer_campaign_id, recipient.user_id, recipient.attachments.delivery_country_id);
        });
      }, $q.when(true));
    }

    function calculate_special_qty(recipients) {
      $scope.steps[4].progress = 0;
      $scope.steps[4].progress_started = true;
      return recipients.reduce(function(promise, recipient, index) {
        return promise.then(function(response) {
          if (response && response.data) {
            recipients[index - 1].matched_quantity = response.data.matched_quantity;
            recipients[index - 1].matched_items = response.data.matched_items;
          }
          $scope.steps[4].progress = Math.ceil((index / recipients.length) * 100);
          return OfferCampaignService.get_matched_quantity($scope.offer_campaign_id, recipient.user_id, recipient.attachments.delivery_country_id);
        });
      }, $q.when(true));
    }

    function embed_matched_special(recipients, min_quantity, max_embedded_matched_rows) {
      $scope.steps[5].progress = 0;
      $scope.steps[5].progress_started = true;
      return recipients.reduce(function(promise, recipient, index) {
        return promise.then(function(response) {
          update_recipient_with_text(index - 1, response);
          $scope.steps[5].progress = Math.ceil((index / recipients.length) * 100);
          console.log(recipient);
          var quantity_pass = false;
          var rows_pass = false;
          if (recipient.min_qty) {
            min_quantity = recipient.min_qty;
          }
          if (recipient.max_rows) {
            max_embedded_matched_rows = recipient.max_rows;
          }
          
          console.log(min_quantity);
          console.log(max_embedded_matched_rows);
          if (min_quantity > 0 && recipient.matched_quantity > min_quantity) {
            quantity_pass = true;
          }
          if (max_embedded_matched_rows > 0 && recipient.matched_items <= max_embedded_matched_rows) {
            rows_pass = true;
          }
          console.log(quantity_pass);
          console.log(rows_pass);
          if ((quantity_pass && rows_pass) || (rows_pass && !(min_quantity > 0)) || (quantity_pass && !(max_embedded_matched_rows > 0))) {
            console.log('embed stocklist!');
            return OfferCampaignService.update_recipient_embed_matched(recipient.id, true);
          } else {
            return true;
          }
        });
      }, $q.when(true));
    }

    function create_special_xls(recipients) {
      $scope.steps[6].progress = 0;
      $scope.steps[6].progress_started = true;
      return recipients.reduce(function(promise, recipient, index) {
        return promise.then(function() {
          $scope.steps[6].progress = Math.ceil((index / recipients.length) * 100);
          return OfferCampaignService.create_special_xls($scope.offer_campaign_id, recipient.user_id, recipient.attachments.delivery_country_id, true, false);
        });
      }, $q.when(true));
    }

    function ignore_pi_xls(recipients) {
      $scope.steps[7].progress = 0;
      $scope.steps[7].progress_started = true;
      return recipients.reduce(function(promise, recipient, index) {
        return promise.then(function(response) {
          update_recipient_with_text(index - 1, response);
          $scope.steps[7].progress = Math.ceil((index / recipients.length) * 100);
          if (recipient.user_data.is_pi)
            return OfferCampaignService.set_recipient_attachment(recipient.id, [{
              key: 'ignore_pi_xls',
              value: true
            }, {
              key: 'stocklist_pi_xls',
              value: false
            }]);
          else
            return true;
        });
      }, $q.when(true));
    }

    function mark_template_done(recipients) {
      $scope.steps[8].progress = 0;
      $scope.steps[8].progress_started = true;
      return recipients.reduce(function(promise, recipient, index) {
        return promise.then(function() {
          $scope.steps[8].progress = Math.ceil((index / recipients.length) * 100);
          return OfferCampaignService.update_recipient_template_text(recipient.id, recipient.template_text, recipient.template_text_per, true);
        });
      }, $q.when(true));
    }

    function update_recipient_with_text(index, response) {
      if (response.data && response.data.template_text)
        $scope.special_recipients[index].template_text = response.data.template_text;
      if (response.data && response.data.template_text_per)
        $scope.special_recipients[index].template_text_per = response.data.template_text_per;
    }

    function create_campaign(offer_id, settings, deferred) {
      var t0 = performance.now();
      set_processing(0);
      var create_data = {
        offer_id: offer_id,
        title: settings.campaign_title,
        title_el: settings.campaign_title_el,
        embed_stocklist: settings.embed_stocklist || false,
        related_offer_id: settings.related_offer_id || null,
        related_offer_prices: settings.related_offer_prices || false,
        hide_offer_prices: settings.hide_offer_prices || false,
        hide_cfr_prices: settings.hide_cfr_prices || false,
        hide_dap_prices: settings.hide_dap_prices || false,
        product_group_specs: settings.product_group_specs || false,
        currency_symbol: settings.currency_symbol || 0,
        use_product_name: settings.use_product_name || false,
        sort_items: settings.sort_items || false,
        sort_items_by_parent_id: settings.sort_items_by_parent_id || false,
        use_custom_template: settings.use_custom_template || false,
        general_text: settings.general_text || null,
        general_text_el: settings.general_text_el || null,
        supplier_text: settings.supplier_text || null,
        supplier_text_el: settings.supplier_text_el || null,
        supplier_text_el_per: settings.supplier_text_el_per || null,
        supplier_text_greeting: settings.supplier_text_greeting || null,
        supplier_text_greeting_el: settings.supplier_text_greeting_el || null,
        supplier_text_greeting_el_per: settings.supplier_text_greeting_el_per || null,
        sender_name: settings.sender_name || null,
        sender_name_el: settings.sender_name_el || null,
        filename_stocklist: settings.filename_stocklist || null,
        filename_stocklist_pi: settings.filename_stocklist_pi || null,
        max_embedded_matched_rows: settings.max_embedded_matched_rows || 0,
        special_notes: settings.special_notes || null,
        target_recipients: settings.target_recipients || null
      };
      OfferCampaignService.create(create_data)
        .then(function(response) {
          $scope.offer_campaign_id = response.data.offer_campaign_id;
          set_processing(1);
          if (settings.campaign_id) {
            return OfferCampaignService.copy_basic_infos(settings.campaign_id, $scope.offer_campaign_id);
          } else {
            return true;
          }
        })
        .then(function(/*response*/) {
          set_processing(2);
          return OfferCampaignService.find_and_add_recipients($scope.offer_campaign_id, settings.filter);
        })
        .then(function(/*response*/) {
          set_processing(3);
          return OfferCampaignService.get_recipients($scope.offer_campaign_id, 0, 1);
        })
        .then(function(response) {
          return create_general_xls(response.data.recipients);
        })
        .then(function() {
          $scope.steps[3].progress = 100;
          set_processing(4);
          return OfferCampaignService.get_recipients($scope.offer_campaign_id, 1, 1);
        })
        .then(function(response) {
          $scope.special_recipients = response.data.recipients;
          return calculate_special_qty($scope.special_recipients);
        })
        .then(function(response) {
          if (response && response.data) {
            $scope.special_recipients[$scope.special_recipients.length - 1].matched_quantity = response.data.matched_quantity;
            $scope.special_recipients[$scope.special_recipients.length - 1].matched_items = response.data.matched_items;
          }

          $scope.steps[4].progress = 100;
          set_processing(5);
          return embed_matched_special($scope.special_recipients, settings.min_quantity, settings.max_embedded_matched_rows);
        })
        .then(function(response) {
          update_recipient_with_text($scope.special_recipients.length - 1, response);
          $scope.steps[5].progress = 100;
          set_processing(6);
          return create_special_xls($scope.special_recipients);
        })
        .then(function() {
          $scope.steps[6].progress = 100;
          set_processing(7);
          return ignore_pi_xls($scope.special_recipients);
        })
        .then(function(response) {
          update_recipient_with_text($scope.special_recipients.length - 1, response);
          $scope.steps[7].progress = 100;
          set_processing(8);
          return mark_template_done($scope.special_recipients);
        })
        .then(function() {
          $scope.steps[8].progress = 100;

          var t1 = performance.now();
          $scope.created_time = [(t1 - t0)/1000];          
          if (deferred) {
            $.fancybox.close();
            $rootScope.$broadcast('update_offer_data', {
              offer_id: offer_id,
              campaign_id: $scope.offer_campaign_id
            });
            deferred.resolve({
              campaign_id: $scope.offer_campaign_id
            });
          } else if (!$scope.send) {
            OfferCampaignService.send_created_campaigns_email([$scope.offer_campaign_id], $scope.created_time );
          }
        })
        .then(function(){
          $.fancybox.close();
          if ($scope.send) {
            $scope.filter  = {
              offer_campaign_id: $scope.offer_campaign_id
            };
            OfferCampaignService.get($scope.filter).success(function(data) {
              $rootScope.$broadcast('show_mass_send_dialog', { 
                campaigns: data.campaigns,
                created_times: $scope.created_time,
                deferred: $q.defer()
              });
            });
          }
        });
    }

  }
}

OfferCampaignCreateDialog.$inject = ['$scope', '$rootScope', '$q', 'OfferCampaignService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-campaign-create-dialog.ctrl.js